module.exports = __webpack_public_path__ + "static/media/blog.943b5bec.svg";